<template>
    <div class="select-wrapper">
        <div class="custom-select" v-for="(variation, index) in productVariations" :key="index">
            <span v-for="(value, key, index) in variation"
                  :key="key"
                  v-if="index === 0"
            >
                {{ value.option_name }}
            </span>
            <select @change="onOptionChanged($event)"
                    class="js-product-variation-select"
                >
                <option value="default">Vyberte</option>
                <option :value="value.option_value_id"
                        v-for="(value, key, index) in variation"
                        :key="key"
                        :data-text="value.value"
                >
                    {{ value.value }}
                </option>
            </select>
            <small class="error" v-if="isErrorOnSelect">Pole je povinné.</small>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            productId: {
                required: true,
                type: String
            },
            productVariations: {
                required: true,
                type: Object
            }
        },

        data() {
            return {
                selectedOptions: [],
                selects: document.getElementsByClassName('js-product-variation-select'),
                isErrorOnSelect: false,
                wasReset: false
            }
        },

        mounted() {
            this.$root.$on('optionsError', () => this.isErrorOnSelect = true );

            this.$root.$on('checkOptions', () =>
                this.$root.$emit('optionsValidation', this.isAllOptionsSelected())
            );
        },

        methods: {
            onOptionChanged(e) {
                this.selects = Array.from(this.selects);

                this.handleSelectedOption(e);

                if ( e.target.value === 'default' ) this.wasReset = true;

                this.sendFilterAjax(e);
            },

            handleSelectedOption(e) {
                if ( e.target.value === 'default' ) this.resetSelects(this.selects);
                else {
                    this.wasReset = false;

                    this.selectedOptions[this.selects.indexOf(e.target)] = e.target.value;
                }
            },

            sendFilterAjax(e) {
                let setDefaultProduct = false;

                if ( this.wasReset ) setDefaultProduct = true;

                axios.post('/api/backend/variation-filter', {
                    defaultProduct: this.productId,
                    setDefaultProduct: setDefaultProduct,
                    options: this.selectedOptions
                }).then( response => {
                    // Disable options podla dostupnych produktov, nachadzame sa v stave kedy
                    // je vybraty jeden select z viacerych ak su
                    if ( response.data.availableProducts && response.data.availableProducts.length )
                        this.handleAvailableOptions(response.data.availableProducts, e);

                    // Ak su vyplnene vsetky options setneme product na frontend s jeho cenou
                    if ( this.isAllOptionsSelected() ) {
                        this.isErrorOnSelect = false;
                        this.setProduct(response.data);
                    }

                    // Ak mame selecty v povodnom stave nastavime povodny product
                    if ( setDefaultProduct ) this.setProduct(response.data);

                }).catch( error => console.log(error) )
            },

            isAllOptionsSelected() {
                return this.selects.length === this.selectedOptions.filter(String).length;
            },

            /**
             * Nastavia sa podla dostupnych produktov moznosti vyberu kombinacii
             * @param availableProducts
             * @param e
             */
            handleAvailableOptions(availableProducts, e) {
                // options z dostupnych produktov
                let options = this.getAvailableOptions(availableProducts);

                // prechadzame selecty
                this.selects.forEach( (select) => {

                    // disable iba na ostatne selecty nie pre ten kotry sme klikli
                    if ( select !== e.target ) {
                        Array.from(select.options).forEach( (option, index) => {
                            if ( index === 0 ) return;

                            // Ak moznost neobsahuje id produktu nastavujeme disable v opacnom pripade ho dame prec
                            if ( !options.includes(option.getAttribute('data-text')) )
                                option.disabled = true;
                            else
                                option.disabled = false;
                        })
                    }
                });
            },

            getAvailableOptions(products) {
                let activeOptions = [];

                products.forEach( (product) => {

                    product.product_option_values.forEach( (option, index) => {
                       activeOptions.push(option.value);
                    });
                });

                return activeOptions;
            },

            /**
             * Odoslanie eventu s datami o dostupnom produkte na zaklade vybratych options
             * @param data
             */
            setProduct(data) { this.$root.$emit('setProduct', data); },

            /**
             * Resetnutie vsetkych selectov do povodneho stavu
             * @param selects
             */
            resetSelects(selects) { selects.forEach( (select) => this.resetSelectOption(select)) },

            /**
             * V selecte nastavime klikatelne vsetky hodnoty
             * a selected nastavime na default hodnotu
             * @param select
             */
            resetSelectOption(select) {
                Array.from(select.options).forEach( (option, index) => {
                    if ( index === 0 ) option.selected = true;

                    option.disabled = false;
                });

                this.selectedOptions = [];
            },
        }
    }
</script>

<style lang="scss">
    .select-wrapper {
        display: flex;
        flex-direction: column;

        .custom-select {
            display: flex;
            flex-direction: column;

            select {
                border-color: #E0E0E0 !important;
            }

            select option:disabled {
                color: #fff;
                background: #dc3545;
            }
        }
    }

    small {

        &.error {
            color: #dc3545;
        }
    }
</style>
